<template>
  <v-card-text>
    <template>
      <v-tabs class="container-formata-tabs">
        <v-tab>Exames</v-tab>
        <v-tab-item>
          <RequisitarExames
            :petId="infoPaciente.PetCodigo"
            :tutorId="infoPaciente.TutorCodigo"
          />
        </v-tab-item>

        <v-tab>Exame - Laudo</v-tab>
        <v-tab-item>
          <RequisitarExamesLaudo
            :petId="infoPaciente.PetCodigo"
            :tutorId="infoPaciente.TutorCodigo"
          />
        </v-tab-item>
        <v-tab>Internação</v-tab>
        <v-tab-item>
          <RequisitarInternacao
            :petId="infoPaciente.PetCodigo"
            :tutorId="infoPaciente.TutorCodigo"
          />
        </v-tab-item>

        <v-tab>Medicação</v-tab>
        <v-tab-item>
          <RequisitarMedicacao
            :petId="infoPaciente.PetCodigo"
            :tutorId="infoPaciente.TutorCodigo"
          />
        </v-tab-item>

        <v-tab>Cirurgia</v-tab>
        <v-tab-item>
          <Requisitar-Cirurgia
            :petId="infoPaciente.PetCodigo"
            :tutorId="infoPaciente.TutorCodigo"
          />
        </v-tab-item>

        <v-tab>Consulta</v-tab>
        <v-tab-item>
          <Requisitar-Consulta
            :tutorId="tutorRequisicao"
            :petId="petRequisicao"
          />
        </v-tab-item>

        <!-- <v-tab>Requisitar Higiene</v-tab>
        <v-tab-item>
          <RequisitarHigiene
            :petId="{
              id_pet: infoPaciente.PetCodigo,
              nome: infoPaciente.NomePet,
            }"
            :tutorId="{
              id_cliente: infoPaciente.TutorCodigo,
              nome: infoPaciente.NomeTutor,
            }"
          />
        </v-tab-item> -->
      </v-tabs>
    </template>

    <!-- <v-card-actions class="justify-end">
      <v-btn text @click="$emit('close')">Close</v-btn>
    </v-card-actions> -->
  </v-card-text>
</template>

<script>
import PetsService from "@/services/pets_service.js";
import RequisitarExames from "@/components/RequisitarExames/index.vue";
import RequisitarExamesLaudo from "@/components/RequisitarExamesLaudo/index.vue";
import PacienteService from "@/services/paciente_service.js";
import RequisitarInternacao from "@/components/RequisitarInternacao/index.vue";
import RequisitarMedicacao from "@/components/RequisitarMedicacao/index.vue";
// import RequisitarHigiene from "@/components/RequisitarHigiene/index.vue";
import RequisitarCirurgia from "@/components/RequisitarCirurgia/index.vue";
import RequisitarConsulta from "@/components/RequisitarConsulta/index.vue";

export default {
  components: {
    RequisitarExames,
    RequisitarExamesLaudo,
    RequisitarInternacao,
    RequisitarMedicacao,
    RequisitarCirurgia,
    RequisitarConsulta,
    // RequisitarHigiene,
  },
  data() {
    return {
      dialogErrorProtuarios: false,
      dialogObservacoes: false,
      infoPaciente: {},
      loadingSearch: false,
      tutores: [],
      pets: [],
      prontuarios: [],
      dialogSelectProntuarios: false,
      dialogProntuarios: false,
      selectedTutorProntuarios: "",
      selectedPetProntuarios: "",
      searchTutorProntuarios: "",
      petService: PetsService.build(),
      requisicoes: ["Exame", "Medicação"],
      dialogSelectRequisicao: false,
      dialogRequisitarExame: false,
      dialogRequisitarMedicacao: false,
      dialogComandas: false,
      selectedRequisicao: "",
      perfil: "",
      dialogRequisitarCirurgia: false,
      dialogRequisitarConsulta: false,
      dialogRequisitarInternacao: false,
      dialogRequisicao: false,
      tutor: {},
      petIdComanda: null,
      tutorRequisicao: {},
      petRequisicao: {},
    };
  },
  props: {
    petId: {
      required: true,
    },
    tutorId: {
      required: true,
    },
    consultaId: {},
  },
  watch: {
    searchTutorProntuarios(nome) {
      if (!nome) {
        return;
      }
      if (
        !nome ||
        !(nome = nome.trim()) ||
        nome.length < 3 ||
        this.loadingSearch
      ) {
        return;
      }
      this.loadingSearch = true;
      this.tutores = [];
      const pacienteService = new PacienteService();
      pacienteService.getPacienteByName(
        {
          onSucess: (status) => (body) => {
            if (status === 200) {
              this.tutores = body.data.pacientes;
            } else {
              this.tutores = [];
            }
          },
          onError: (error) => {
            console.error(error);
            this.tutores = [];
          },
          onEnd: () => {
            this.loadingSearch = false;
          },
        },
        nome
      );
    },
    selectedTutorProntuarios() {
      this.pets = "";
      this.pets = this.selectedTutorProntuarios.pets;
    },
  },
  async beforeMount() {
    this.infoPaciente = await JSON.parse(localStorage.getItem("infoPaciente"));

    if (!this.infoPaciente) {
      this.infoPaciente = {
        PetCodigo: this.petId,
        TutorCodigo: this.tutorId,
      };
    }
    this.perfil = JSON.parse(sessionStorage.vuex).perfil.id;
    this.carregarPet();
  },
  methods: {
    carregarPet() {
      this.tutorRequisicao = {
        nome: this.infoPaciente.NomeTutor,
        id_cliente: this.infoPaciente.TutorCodigo,
      };
      this.petRequisicao = {
        nome: this.infoPaciente.NomePet,
        id_pet: this.infoPaciente.PetCodigo,
      };
    },
    async listProntuarios() {
      await this.petService
        .getConsultasbyUnidade(
          this.infoPaciente.PetCodigo,
          JSON.parse(sessionStorage.vuex).unidade.id
        )
        // .getConsultas(this.infoPaciente.PetCodigo)
        .then(async (response) => {
          const data = await response.json();
          if (response.status !== 200) {
            // this.$_ACTIONS_showSnackbarMessage({
            //   message: data.message,
            //   color: "error",
            // });
            this.dialogErrorProtuarios = true;
            return;
          }
          console.log(data);
          this.prontuarios = data.data.consultas;
          this.dialogProntuarios = true;
          this.dialogSelectProntuarios = false;
        });
    },
    requisitar() {
      this.dialogSelectRequisicao = false;

      if (this.selectedRequisicao == "Exame") {
        this.dialogRequisitarExame = true;
      } else if (this.selectedRequisicao == "Medicação") {
        this.dialogRequisitarMedicacao = true;
      }
    },
    // dialogSelectPront() {
    //   this.selectedPetProntuarios = "";
    //   this.selectedTutorProntuarios = "";
    //   this.searchTutorProntuarios = "";
    //   this.dialogSelectProntuarios = true;
    // },
  },
};
</script>
<style>
.container-formata-tabs {
  width: 100%;
}
.modal-nav-ajustes {
  background-color: #1daf80 !important;
  color: #ffffff !important;
  font-size: 1.5rem;
  font-weight: 500;
}
</style>
